import { memo, type ReactNode } from 'react'

import { Skeleton } from '@/components/ui/skeleton'
import { TableCell, TableRow } from '@/components/ui/table'

interface DataTableSkeletonRowProps {
  rowId: string
  rowIndex: number
  columnIdList: string[]
  hasCheckbox: boolean
  hasActions: boolean
}

/**
 * Renders a single skeleton row for the data table loading state.
 */
const DataTableSkeletonRowBase: React.FC<DataTableSkeletonRowProps> = ({
  rowId,
  rowIndex,
  columnIdList,
  hasCheckbox,
  hasActions,
}): ReactNode => (
  <TableRow>
    {hasCheckbox && (
      <TableCell>
        <Skeleton className="size-4" />
      </TableCell>
    )}
    {columnIdList.map((colId) => (
      <TableCell key={`${rowId}-${colId}`}>
        <Skeleton className="h-4" style={{ width: `${60 + ((rowIndex * 7) % 40)}%` }} />
      </TableCell>
    ))}
    {hasActions && (
      <TableCell>
        <Skeleton className="size-8" />
      </TableCell>
    )}
  </TableRow>
)

export const DataTableSkeletonRow = memo(DataTableSkeletonRowBase)

DataTableSkeletonRow.displayName = 'DataTableSkeletonRow'
